export const TiposAnexosEnum = {
    NOTA_FISCAL: 'Nota Fiscal',
    CADASTRO_RM: 'Cadastro RM',
    COMPROVANTE: 'Comprovante',
};
